require('./angular-messages');
module.exports = 'ngMessages';



//////////////////
// WEBPACK FOOTER
// ./~/angular-messages/index.js
// module id = 1141
// module chunks = 5